import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { Switch } from "../components/ui/switch";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { toast } from "sonner";

export default function SettingsPage() {
  const { user, logout } = useAuth();
  const [safeSearch, setSafeSearch] = useState(true);
  const [aiSummary, setAiSummary] = useState(true);
  const [openNewTab, setOpenNewTab] = useState(true);
  const navigate = useNavigate();

  const save = () => {
    localStorage.setItem("omni-settings", JSON.stringify({ safeSearch, aiSummary, openNewTab }));
    toast.success("Préférences enregistrées");
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 max-w-3xl w-full mx-auto px-4 sm:px-6 py-12">
        <h1 className="text-3xl font-black tracking-tight mb-2">Paramètres</h1>
        <p className="text-gray-500 mb-10">Affinez le comportement d'OmniSearch.</p>

        <section className="space-y-6">
          {[
            { id: "safeSearch", v: safeSearch, set: setSafeSearch, t: "Recherche sûre", d: "Masque les contenus explicites quand c'est possible." },
            { id: "aiSummary", v: aiSummary, set: setAiSummary, t: "Résumé IA", d: "Affiche un résumé Claude en haut des résultats web." },
            { id: "openNewTab", v: openNewTab, set: setOpenNewTab, t: "Ouvrir dans un nouvel onglet", d: "Les liens externes s'ouvrent toujours dans un nouvel onglet." },
          ].map((s) => (
            <div key={s.id} className="flex items-start justify-between gap-6 py-4 border-b border-[var(--omni-border)]" data-testid={`setting-${s.id}`}>
              <div>
                <Label htmlFor={s.id} className="text-base font-medium">{s.t}</Label>
                <p className="text-sm text-gray-500 mt-1">{s.d}</p>
              </div>
              <Switch id={s.id} checked={s.v} onCheckedChange={s.set} />
            </div>
          ))}
        </section>

        <div className="mt-10 flex gap-3">
          <Button onClick={save} className="bg-[var(--omni-accent)] hover:bg-[var(--omni-accent-hover)] text-white rounded-full" data-testid="save-settings-btn">Enregistrer</Button>
          {user && user !== false && (
            <Button variant="outline" onClick={async () => { await logout(); navigate("/"); }} data-testid="settings-logout-btn" className="rounded-full">Se déconnecter</Button>
          )}
        </div>

        <p className="text-xs text-gray-400 mt-12">
          Curieux ? Tapez le <Link to="/h4ck" className="text-[var(--omni-accent)] hover:underline">Konami Code</Link> sur la page d'accueil.
        </p>
      </main>
      <Footer />
    </div>
  );
}
